var swatchSyncAsync = function () {
  var swatchLinks = document.querySelectorAll('.check.color li a:not(.swatch-sync-init)');
  Array.from(swatchLinks).forEach(function (link) {
    link.classList.add('swatch-sync-init');
    link.addEventListener('click', function (e) {
      var card = link.closest('.product-card');
      var li = link.closest('li');
      var radio = li.querySelector('input[type="radio"]');
      var quickshopBtn = card ? card.querySelector('[data-quickshop]') : null;

      if (!radio) return;

      // Only intercept if there's a quickshop button to sync — otherwise let it navigate normally
      if (quickshopBtn) {
        e.preventDefault();
        radio.checked = true;

        var variantId = radio.value;
        var baseHref = quickshopBtn.getAttribute('href').split('?')[0];
        quickshopBtn.setAttribute('href', baseHref + '?variant=' + variantId);
      }
    });
  });
};
swatchSyncAsync();